module.exports = __webpack_public_path__ + "static/media/pacgor_logo_white.ec5d9846.png";